import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { LocalCartItemPricing } from 'restful/tickets';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';
import TicketInfoCard, {
  type TicketInfoChildRow,
} from 'components/@tickets/TicketInfoCard';

import CartCheckoutButton from './CartCheckoutButton';

interface Props {
  open: boolean;
  items: Array<LocalCartItemPricing>;
  cartTotalOriginalPrice: number;
  cartTotalDiscountedPrice: number;
  cartItemsCount: number;
  isLoadingCheckout: boolean;
  isLoyaltyEffectLoading: boolean;
  onClose: () => void;
  onCheckout: () => void;
  onDeleteItem: (item: LocalCartItemPricing) => void;
  getChildRows: (item: LocalCartItemPricing) => Array<TicketInfoChildRow>;
}

const OrderSummaryDialog = ({
  open,
  items,
  cartTotalOriginalPrice,
  cartTotalDiscountedPrice,
  cartItemsCount,
  isLoadingCheckout,
  isLoyaltyEffectLoading,
  onClose,
  onCheckout,
  onDeleteItem,
  getChildRows,
}: Props) => {
  const handleCloseDrawer = () => {
    onClose();
  };

  return (
    <ResponsiveDrawerDialog isOpen={open} onClose={handleCloseDrawer}>
      <DialogTitle>
        <Typography
          variant="h6"
          sx={{
            mb: '2px',
          }}
        >
          <FormattedMessage id="tickets.checkout.order.summary.title" />
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            gap: 1,
          }}
        >
          {items.map((item) => {
            return (
              <TicketInfoCard
                key={item.catalogueItemId}
                item={item}
                childRows={getChildRows(item)}
                onDeleteItem={() => onDeleteItem(item)}
              />
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <CartCheckoutButton
          cartItemsCount={cartItemsCount}
          cartTotalOriginalPrice={cartTotalOriginalPrice}
          cartTotalDiscountedPrice={cartTotalDiscountedPrice}
          onOpenOrderSummary={onClose}
          onCheckout={onCheckout}
          isLoadingCheckout={isLoadingCheckout}
          isLoyaltyEffectLoading={isLoyaltyEffectLoading}
          variant="orderSummary"
        />
      </DialogActions>
    </ResponsiveDrawerDialog>
  );
};

export default OrderSummaryDialog;
